import upsss from "../assets/img/otros/upsss.png";

//Importación Estilos
import styles from "../css/components/SinDatos.module.css";

export function SinDatos() {
  return (
    <div className={styles.containerSinDatos}>
      <img src={upsss} alt="Upsss" className={styles.imgUps} />
      <div className={styles.containerMessage}>
        <h3>Upsss !!!</h3>
        <p>Lo sentimos, no se encontró ningún dato para mostrar.</p>
        <small>Por favor comuníquese con el administrador del sistema.</small>
      </div>
    </div>
  );
}
